module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-headphones-bbeefe4cc7ec27b345effcb7bd21e52d.png";